export default __webpack_public_path__ + "static/media/nft1.d629ef0a.png";